const getRoute = (): string => {
  const url = typeof window !== "undefined" ? window.location.href : ""
  return url.slice(process.env.GATSBY_URL?.length)
}

export default getRoute
